import { SOURCE_QUERY_PARAM_KEY } from "@simplyk/common";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

import { SubmitCommandInput } from "../types/trpc";

export const ImpactChainUtmSourceName = "impact_chain_source"; // remove utm from name to avoid creating a custom question
export const OldImpactChainUtmSourceName = "utm_impact_chain_source";

type PurchaseAttribution = Pick<
  SubmitCommandInput,
  "purchasedFromEmailDeliveryId" | "purchasedFromEmailId" | "purchasedFromPostMailId" | "impactChainUtmSourceEmail"
>;

export const useFormQueryParams = () => {
  const searchParams = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const emailDeliveryId = searchParams.get("emailDeliveryId");
  const emailId = searchParams.get("emailId");
  const postMailId = searchParams.get("postMailId");
  const source = searchParams.get(SOURCE_QUERY_PARAM_KEY);
  const impactChainUtmSourceEmail =
    searchParams.get(ImpactChainUtmSourceName) || searchParams.get(OldImpactChainUtmSourceName);
  // eslint-disable-next-line zeffy-linter-frontend/avoid-router-query
  const { query } = useRouter();

  const { donationFormId, campaignId, ticketingId } = query as {
    donationFormId?: string;
    campaignId?: string;
    ticketingId?: string;
  };

  const purchaseAttribution: PurchaseAttribution = {
    purchasedFromEmailDeliveryId: emailDeliveryId || undefined,
    purchasedFromEmailId: emailId || undefined,
    purchasedFromPostMailId: postMailId || undefined,
    impactChainUtmSourceEmail: impactChainUtmSourceEmail || undefined,
  };

  return {
    sessionId,
    source,
    donationFormId,
    campaignId,
    ticketingId,
    impactChainUtmSourceEmail,
    purchaseAttribution,
  };
};
